import { AttributesTable } from '@/components/features/attributes/AttributesTable'

export const Attributes = () => {
  return (
    <div >
      <AttributesTable />
    </div>
  )
}

export default Attributes
